export default "/cars-for-sale";